module.exports = __webpack_public_path__ + "static/media/GTBSAnimatedBig.0e7d959b.webp";